import arnav from '../public/Arnav.jpg'
import yatharth from '../public/yatharth (2).jpg'
import lovely from '../public/Lovely.jpg'
import soham from '../public/Soham.jpg'
import anushka from '../public/anushka.jpeg'
export const MachineLearning = [
    {
        id: 1,
        name: 'Arnav Jain',
        image_url:arnav,
        description : 'Machine Learning',       
    },
    {
        id: 2,
        name: 'Yatharth Gupta',
        image_url:yatharth,
        description : 'Machine Learning',       
    },
    {
        id:3,
        name: 'Lovely',
        image_url:lovely,
        description:'Machine Learning',
    },
    {
        id:4,
        name:'Soham',
        image_url: soham,
        description: 'Machine Learning'
    },
    {
        id:5,
        name:'Anushka Jha',
        image_url: anushka,
        description: 'Machine Learning'
    }
    
]
